import { Routes } from '@angular/router'

import { Layout } from './layout/layout'
import { isAuthenticatedGuard, isNotAuthenticatedGuard } from '@core/auth'

export const routes: Routes = [
  {
    path: '',
    component: Layout,
    canActivate: [isAuthenticatedGuard],
    children: [
      {
        path: '',
        redirectTo: '/muro',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('@features/home/home.routes').then(m => m.routes)
      },
      {
        path: 'muro',
        loadChildren: () => import('@features/muro/muro.routes').then(m => m.routes)
      },
      {
        path: 'personas',
        loadChildren: () => import('@features/personas/personas.routes').then(m => m.routes)
      },
      {
        path: 'tramites',
        loadChildren: () => import('@features/tramites/tramites.routes').then(m => m.routes)
      },
      {
        path: 'noticias',
        loadChildren: () => import('@features/noticias/noticias.routes').then(m => m.routes)
      },
      {
        path: 'reconocimientos',
        loadChildren: () => import('@features/reconocimientos/reconocimientos.routes').then(m => m.routes)
      },
      {
        path: 'mis-documentos',
        loadChildren: () => import('@features/mis-documentos/mis-documentos.routes').then(m => m.routes)
      },
      {
        path: 'encuestas',
        loadChildren: () => import('@features/encuestas/encuestas.routes').then(m => m.routes)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./pages/perfil-page/perfil-page').then(m => m.PerfilPage)
      }
    ]
  },
  {
    path: 'complete_signup',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('@features/auth/pages/complete-signup-page/complete-signup-page').then(m => m.CompleteSignupPage)
  },
  {
    path: '',
    canActivate: [isNotAuthenticatedGuard],
    loadChildren: () => import('@features/auth/auth.routes').then(m => m.routes)
  }
]
